import React from 'react'

function error() {
    return (
        <h1>
            Whoopise, it seems that url does not exists!
        </h1>
    );
}

export default error;